import { render, staticRenderFns } from "./CardVideo.vue?vue&type=template&id=38fc4f2f&scoped=true&"
import script from "./CardVideo.vue?vue&type=script&lang=js&"
export * from "./CardVideo.vue?vue&type=script&lang=js&"
import style0 from "./CardVideo.vue?vue&type=style&index=0&id=38fc4f2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc4f2f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCol,VIcon,VProgressLinear,VRow})
